import { Component, Input, OnInit } from '@angular/core';

export enum badgeRenditionEnum {
  '',
  'secondary',
}

export enum badgePositionEnum {
  '',
  'tr',
  'bc'
}

export declare type badgeRendition = keyof typeof badgeRenditionEnum;

export declare type badgePosition = keyof typeof badgePositionEnum;

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.less']
})
export class BadgeComponent implements OnInit {
  @Input() badgeCopy: string;
  @Input() addTopSpacer: boolean;
  @Input() showStreamzPromoBadge: boolean;
  @Input() rendition: badgeRendition = '';
  @Input() position: badgePosition = '';

  classes: string[] = [];

  constructor() {
  }

  ngOnInit() {
  }

}
